<lg-sidebar
  [open]="isOpen()"
  (openChange)="onOpenChange($event)"
  [userProfile]="userProfile()"
  brandLogoSrc="assets/img/logo.png"
  [overlayZIndex]="998"
  [panelZIndex]="999"
>
  <nav aria-label="Menú de navegación principal">
    <ul class="tw-m-0 tw-list-none tw-p-0">
      @for (option of sidebarOptions; track option.id) {
        <li
          class="lg-sidebar-item tw-list-none"
          *hasPermissions="
            option.module;
            for: ['view'];
            visible: option.visible || false
          "
        >
          @if (option.subOptions) {
            <a
              class="lg-sidebar-link lg-sidebar-link--toggle tw-no-underline"
              href="#"
              role="button"
              [class.collapsed]="!isSectionOpen(option.id)"
              [attr.aria-expanded]="isSectionOpen(option.id)"
              [attr.aria-controls]="option.id + '-submenu'"
              (click)="toggleSection(option.id, $event)"
            >
              <span
                class="tabler-mask-icon sidebar-icon"
                [style.--tabler-icon]="iconUrl(option.icon)"
                aria-hidden="true"
              ></span>
              {{ option.label }}
            </a>
            <div
              class="lg-sidebar-submenu"
              [id]="option.id + '-submenu'"
              [class.show]="isSectionOpen(option.id)"
            >
              <ul class="lg-sidebar-submenu-list tw-m-0 tw-list-none tw-p-0">
                @for (subItem of option.subOptions; track subItem.label) {
                  <li
                    class="lg-sidebar-item tw-list-none"
                    *hasPermissions="
                      subItem.module;
                      for: ['view'];
                      visible: subItem.visible || false
                    "
                  >
                    <a
                      class="lg-sidebar-link tw-no-underline"
                      [routerLink]="subItem.linkTo"
                      [queryParams]="subItem.params ?? null"
                      routerLinkActive="router-link-active"
                      [routerLinkActiveOptions]="activeLinkOptions"
                      (click)="navigate()"
                    >
                      <span
                        class="tabler-mask-icon sidebar-icon"
                        [style.--tabler-icon]="iconUrl(subItem.icon)"
                        aria-hidden="true"
                      ></span>
                      {{ subItem.label }}
                    </a>
                  </li>
                }
              </ul>
            </div>
          } @else if (option.linkTo) {
            <a
              class="lg-sidebar-link tw-no-underline"
              [routerLink]="option.linkTo"
              [queryParams]="option.params ?? null"
              routerLinkActive="router-link-active"
              [routerLinkActiveOptions]="activeLinkOptions"
              (click)="navigate()"
            >
              <span
                class="tabler-mask-icon sidebar-icon"
                [style.--tabler-icon]="iconUrl(option.icon)"
                aria-hidden="true"
              ></span>
              {{ option.label }}
            </a>
          }
        </li>
      }
    </ul>
  </nav>
</lg-sidebar>
